<template>
  <div>
    <img
      :src="value.image"
      :alt="value.alternativeText">
  </div>
</template>

<script>
export default {
  name: "ControlMedia",
  props: {
    value: {
      type: String,
      default: null,
    },
  },
};
</script>

<style lang="scss" scoped>
img {
  max-width: 100%;
}
</style>
